<template>
    <div style="margin-top: 20px;">
        <div class="container">
            <v-alert class="alert-info" type="success" :value="show_alert">Copied</v-alert>
            <div class="navigation">
                <span @click="goToAlumniStories" class="nav-active font-poppins">Cerita Alumni</span>
                <Arrow :width="20" direct="left" />
                <span class="font-poppins">Detail Alumni Stories</span>
            </div>
            <img loading="lazy" :src="story.image_url" class="img-main-desktop" />
            <h2 style="line-height: 28px;">{{ story.title }}</h2>
            <div>
                <div style="margin-bottom: 20px">
                    <p>{{ formatDate(story.date_release) }} WIB</p>
                    <div style="display: flex; gap: 10px; align-items: center;">
                        <hi-col />
                        <span>HiColleagues Team</span>
                    </div>
                </div>
                <div
                    style="display: flex; gap: 10px; align-items: flex-start; padding: 10px 0; border-top: 1px solid #D3D6E1; border-bottom: 1px solid #D3D6E1; margin-bottom: 20px;">
                    <span @click="onShare('ld')">
                        <linkedin />
                    </span>
                    <span @click="onShare('fc')">
                        <facebook />
                    </span>
                    <span @click="onShare('ig')">
                        <instagram />
                    </span>
                    <span @click="onShare('wa')">
                        <whatsapp />
                    </span>
                    <span @click="onShare('cp')">
                        <copy />
                    </span>
                </div>
            </div>
            <div class="text-left mt-5" v-html="story.body"></div>
        </div>
        <v-card elevation="0" class="call-center-container">
            <v-row style="padding: 20px 0px">
                <v-col cols="12">
                    <div class="call-center-title">
                        {{ $t('alumniHelpTitle') }}
                    </div>
                    <div class="call-center-desc">
                        {{ $t('alumniHelpDescription') }}
                    </div>
                </v-col>
                <v-col cols="12" class="call-center-button" @click="sendWa">
                    <v-btn class="btn" elevation="0"> {{ $t('alumniAct') }} </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';

import Arrow from "@/assets/icons/Arrow.vue";
import Facebook from '@/assets/icons/blog/Facebook.vue';
import Linkedin from '@/assets/icons/blog/Linkedin.vue';
import Copy from '@/assets/icons/blog/Copy.vue';
import HiCol from '@/assets/icons/blog/HiCol.vue';
import Instagram from '@/assets/icons/blog/Instagram.vue';
import Whatsapp from '@/assets/icons/blog/Whatsapp.vue';

export default {
    name: "MobileDetailAlumniStories",
    components: {
        Arrow,
        Facebook,
        Copy,
        Linkedin,
        HiCol,
        Instagram,
        Whatsapp
    },
    data() {
        return {
            show_alert: false,
            story: {
                image_url: "",
                title: "",
                caption: "",
                body: "",
                date_release: ""
            }
        }
    },
    watch: {
        show_alert() {
            if (!this.show_alert) return;
            setTimeout(() => {
                this.show_alert = false;
            }, 3000);
        },
        "$i18n.locale"() {
            this.getAlumniStoriesDetail();
        },
    },
    methods: {
        sendWa() {
            this.$gtag.event('click', {
                event_category: 'Button',
                event_label: 'Contact WhatsApp - Mobile Alumni Story Detail',
                value: 1,
            });
            window.open("https://wa.me/6281234567890", "_blank");
        },
        formatDate(date) {
            return moment(date).utc().format("dddd, DD MMMM YYYY - hh:mm");
        },
        onShare(type) {
            let url = "";
            let event_label = "";
            if (type === 'ld') {
                url = `https://www.linkedin.com/company/hicolleagues/?originalSubdomain=id`;
                event_label = 'Share LinkedIn - Mobile Alumni Story';
            } else if (type === 'fc') {
                url = `https://www.facebook.com/hicolleagues/`;
                event_label = 'Share Facebook - Mobile Alumni Story';
            } else if (type === 'ig') {
                url = `https://www.instagram.com/hicolleagues/`;
                event_label = 'Share Instagram - Mobile Alumni Story';
            } else if (type === 'wa') {
                url = "https://wa.me/6281234567890";
                event_label = 'Share WhatsApp - Mobile Alumni Story';
            } else if (type === 'cp') {
                this.onCopyUrl();
                return;
            }
            this.$gtag.event('click', {
                event_category: 'Social Media',
                event_label: event_label,
                value: 1,
            });
            window.open(url, '_blank');
        },
        onCopyUrl() {
            this.$gtag.event('click', {
                event_category: 'Button',
                event_label: 'Copy URL - Mobile Alumni Story',
                value: 1,
            });
            const clipboardData =
                event.clipboardData ||
                window.clipboardData ||
                event.originalEvent?.clipboardData ||
                navigator.clipboard;
            clipboardData.writeText(window.location.href);
            this.show_alert = true;
        },
        async getAlumniStoriesDetail() {
            try {
                const resp = await this.$http.get(`/v1/alumni-stories/${this.$route.params.id}`);
                this.story = resp.data.data.stories;
            } catch (err) {
                console.log(err);
            }
        },
        goToAlumniStories() {
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: 'Back to Alumni Stories - Mobile',
                value: 1,
            });
            this.$router.push('/alumni-stories');
        },
    },
    mounted() {
        this.getAlumniStoriesDetail();
    }
}
</script>

<style scoped src="./detail.css"></style>
